module.exports = __webpack_public_path__ + "img/logo-darkmode.022a90d0.svg";